import React, { Ref, forwardRef, useState } from 'react';
import clsx from 'clsx';
import css from './TextArea.module.css';
import { TextAreaResize } from '../../models';

interface TextAreaProps {
  placeholder?: string;
  disabled?: boolean;
  resize?: TextAreaResize;
  inputMode: 'text';
  onFocus: () => void;
  onBlur: () => void;
  onChange: (value: string) => void;
  value: string;
}

const TextAreaComponent: React.ForwardRefRenderFunction<
  HTMLTextAreaElement,
  TextAreaProps
> = (props: TextAreaProps, ref: Ref<HTMLTextAreaElement>) => {
  const { disabled = false } = props;
  const [height, setHeight] = useState<number | undefined>(undefined);

  const resizeStyle = (): string | undefined => {
    const resize = props.resize ?? TextAreaResize.Both;

    switch (resize) {
      case TextAreaResize.Both:
        return css.resizeBoth;
      case TextAreaResize.Horizontal:
        return css.resizeHorizontal;
      case TextAreaResize.Vertical:
        return css.resizeVertical;
      case TextAreaResize.None:
      default:
        return css.resizeNone;
    }
  };

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(event.target.value);

    const currentHeight = height ? height : event.target.offsetHeight;
    const scrollHeight = event.target.scrollHeight;
    if (scrollHeight > currentHeight) {
      setHeight(scrollHeight);
    }
  };

  return (
    <textarea
      ref={ref}
      value={props.value === null ? '' : props.value}
      disabled={disabled}
      className={clsx(css.textArea, resizeStyle())}
      inputMode={props.inputMode}
      placeholder={props.placeholder}
      autoCapitalize="off"
      autoComplete="off"
      rows={2}
      onChange={onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      style={height ? { height } : {}}
    />
  );
};

const TextArea = forwardRef(TextAreaComponent);

export default TextArea;
